module.exports = __webpack_public_path__ + "img/instruments-search.1bafb50b.svg";